export default {
  resuscitation: {
    resuscitationDocumentation: {
      needsTwoValues: {
        issues: [
          {
            id: 'I-GE-CH-4200',
            domain: 'DGEP'
          }
        ],
        field1: {
          triggerValue: 'no',
          name: 'resuscitation'
        },
        field2: {
          triggerValue: 'no',
          name: 'resuscitationDocumentation'
        }
      }
    }
  },
  livingWill: {
    noDocumentation: {
      issues: [
        {
          id: 'I-GE-CH-1000',
          domain: 'DGEP'
        }
      ]
    },
    LWHave: {
      unDocumented: {
        issues: [
          {
            id: 'I-GE-CH-1000',
            domain: 'DGEP'
          }
        ]
      }
    },
    LWChanges: {
      issues: [
        {
          id: 'I-GE-CH-1100',
          domain: 'DGEP'
        }
      ],
      triggerValue: 'yes'
    },
    LWCopies: {
      issues: [
        {
          id: 'I-GE-CH-1200',
          domain: 'DGEP'
        }
      ],
      triggerValue: 'no'
    },
    LWNarusCopy: {
      issues: [
        {
          id: 'I-GE-CH-1300',
          domain: 'DGEP'
        }
      ],
      triggerValue: 'no'
    },
    LWQuestions: {
      issues: [
        {
          id: 'I-GE-CH-1400',
          domain: 'DGEP'
        }
      ],
      triggerValue: 'yes'
    },
    LWSendCopies: {
      issues: [
        {
          id: 'I-GE-CH-1500',
          domain: 'DGEP'
        }
      ],
      triggerValue: 'yes'
    },
    LWLearning: {
      issues: [
        {
          id: 'I-GE-CH-1600',
          domain: 'DGEP'
        }
      ],
      triggerValue: 'yes'
    },
    LWComplete: {
      issues: [
        {
          id: 'I-GE-CH-1700',
          domain: 'DGEP'
        }
      ],
      triggerValue: 'yes'
    }
  },
  advancedDirective: {
    noDocumentation: {
      issues: [
        {
          id: 'I-GE-CH-1800',
          domain: 'DGEP'
        }
      ]
    },
    ADHave: {
      unDocumented: {
        issues: [
          {
            id: 'I-GE-CH-1800',
            domain: 'DGEP'
          }
        ]
      }
    },
    ADChanges: {
      issues: [
        {
          id: 'I-GE-CH-1900',
          domain: 'DGEP'
        }
      ],
      triggerValue: 'yes'
    },
    ADCopies: {
      issues: [
        {
          id: 'I-GE-CH-2000',
          domain: 'DGEP'
        }
      ],
      triggerValue: 'no'
    },
    ADNarusCopy: {
      issues: [
        {
          id: 'I-GE-CH-2100',
          domain: 'DGEP'
        }
      ],
      triggerValue: 'no'
    },
    ADQuestions: {
      issues: [
        {
          id: 'I-GE-CH-2200',
          domain: 'DGEP'
        }
      ],
      triggerValue: 'yes'
    },
    ADSendCopies: {
      issues: [
        {
          id: 'I-GE-CH-2300',
          domain: 'DGEP'
        }
      ],
      triggerValue: 'yes'
    },
    ADLearning: {
      issues: [
        {
          id: 'I-GE-CH-2400',
          domain: 'DGEP'
        }
      ],
      triggerValue: 'yes'
    },
    ADComplete: {
      issues: [
        {
          id: 'I-GE-CH-2500',
          domain: 'DGEP'
        }
      ],
      triggerValue: 'yes'
    }
  },
  dnr: {
    noDocumentation: {
      issues: [
        {
          id: 'I-GE-CH-2600',
          domain: 'DGEP'
        }
      ]
    },
    DNRHave: {
      unDocumented: {
        issues: [
          {
            id: 'I-GE-CH-2600',
            domain: 'DGEP'
          }
        ]
      }
    },
    DNRChanges: {
      issues: [
        {
          id: 'I-GE-CH-2700',
          domain: 'DGEP'
        }
      ],
      triggerValue: 'yes'
    },
    DNRCopies: {
      issues: [
        {
          id: 'I-GE-CH-2800',
          domain: 'DGEP'
        }
      ],
      triggerValue: 'no'
    },
    DNRNarusCopy: {
      issues: [
        {
          id: 'I-GE-CH-2900',
          domain: 'DGEP'
        }
      ],
      triggerValue: 'no'
    },
    DNRQuestions: {
      issues: [
        {
          id: 'I-GE-CH-3000',
          domain: 'DGEP'
        }
      ],
      triggerValue: 'yes'
    },
    DNRSendCopies: {
      issues: [
        {
          id: 'I-GE-CH-3100',
          domain: 'DGEP'
        }
      ],
      triggerValue: 'yes'
    },
    DNRLearning: {
      issues: [
        {
          id: 'I-GE-CH-3200',
          domain: 'DGEP'
        }
      ],
      triggerValue: 'yes'
    },
    DNRComplete: {
      issues: [
        {
          id: 'I-GE-CH-3300',
          domain: 'DGEP'
        }
      ],
      triggerValue: 'yes'
    }
  },
  post: {
    noDocumentation: {
      issues: [
        {
          id: 'I-GE-CH-3400',
          domain: 'DGEP'
        }
      ]
    },
    PPHave: {
      unDocumented: {
        issues: [
          {
            id: 'I-GE-CH-3400',
            domain: 'DGEP'
          }
        ]
      }
    },
    PPChanges: {
      issues: [
        {
          id: 'I-GE-CH-3500',
          domain: 'DGEP'
        }
      ],
      triggerValue: 'yes'
    },
    PPCopies: {
      issues: [
        {
          id: 'I-GE-CH-3600',
          domain: 'DGEP'
        }
      ],
      triggerValue: 'no'
    },
    PPNarusCopy: {
      issues: [
        {
          id: 'I-GE-CH-3700',
          domain: 'DGEP'
        }
      ],
      triggerValue: 'no'
    },
    PPQuestions: {
      issues: [
        {
          id: 'I-GE-CH-3800',
          domain: 'DGEP'
        }
      ],
      triggerValue: 'yes'
    },
    PPSendCopies: {
      issues: [
        {
          id: 'I-GE-CH-3900',
          domain: 'DGEP'
        }
      ],
      triggerValue: 'yes'
    },
    PPLearning: {
      issues: [
        {
          id: 'I-GE-CH-4000',
          domain: 'DGEP'
        }
      ],
      triggerValue: 'yes'
    },
    PPComplete: {
      issues: [
        {
          id: 'I-GE-CH-4100',
          domain: 'DGEP'
        }
      ],
      triggerValue: 'yes'
    }
  }
}
